import React from 'react';
import { AnimatedLogo } from '../../../../../ui';

type LoadingSpinnerProps = {
  label?: string;
};

const LoadingSpinner = ({ label = 'Loading...' }: LoadingSpinnerProps) => {
  return (
    <div className='absolute inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-900 z-50'>
      <div className='relative'>
        <AnimatedLogo />
        { /* Circular progress indicator */ }
        <div className='absolute inset-0 flex items-center justify-center'>
          <div className='h-24 w-24 rounded-full border-t-2 border-b-2 border-blue-500 animate-spin opacity-20' />
        </div>
      </div>
      <div className='mt-4 text-sm font-medium text-gray-600 dark:text-gray-300'>
        { label }
      </div>
    </div>
  );
};

export default LoadingSpinner;
